<template>
  <v-alert
    class="PrepareSignatureTagAlert"
    :color="backgroundColor"
    :style="`borderColor:${color}33`"
  >
    <div class="d-flex align-center">
      <app-material-icon
        :name="computedIcon"
        :color="color"
        class="mr-1"
      />
      <span class="PrepareSignatureTagAlert-text">{{ message }}</span>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { AppAlertBackgroundColor, AppAlertColor, AppAlertIcon } from '@/design-system/alert/enums'
import { AppAlertVariant } from '@/design-system/alert/types'

export default defineComponent({
  name: 'PrepareSignatureTagAlert',
  props: {
    message: {
      type: String,
      required: true,
    },
    variant: {
      type: String as PropType<AppAlertVariant>,
      default: 'info',
    },
  },
  computed: {
    backgroundColor (): string {
      return AppAlertBackgroundColor[this.variant].valueOf()
    },
    color (): string {
      return AppAlertColor[this.variant].valueOf()
    },
    computedIcon (): string {
      return AppAlertIcon[this.variant].valueOf()
    },
  },
})
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";
@import "@/scss/box-shadow-tokens";
@import "@/scss/elevation-tokens";

.PrepareSignatureTagAlert {
  @include border-radius('border-radius-3');
  @include border-style('border-solid');
  @include border-width('border-width-1');
  @include box-shadow('box-shadow-low');
  left: 0;
  margin-top: -42px;
  padding: 4px 8px;
  position: absolute;
  top: 0;
  width: max-content;
  @include elevation('z-index-popover');

  &-text {
    color: rgb(var(--v-theme-accent));
    font-size: 13px;
    font-style: normal;
  }
}
</style>
